import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import Modal from './Modal';
import i18n from '../utils/i18n';
import routeConstants from '../utils/routeConstants';
import { resetModal } from '../actions/modalsActions';

import './styles/BookingCompleteModal.scss';

const StartResetingPasswordSuccessModal = ({ resetModal: reset, dispatch }) => (
  <Modal
    isOpen={ true }
    onRequestClose={ () => {
      reset();
      dispatch(push(routeConstants.HOME_ROUTE));
    } }
    closeButtonText={ i18n.t('modals.startResetingPasswordSuccess.OK') }
    showActionButton={ false }
  >
    <div className="modal-container">
      <h1 className="modal-header">
        {i18n.t(
          'modals.startResetingPasswordSuccess.START_RESETING_PASSWORD_SUCCESS'
        )}
      </h1>
      <span>
        {i18n.t('modals.startResetingPasswordSuccess.PLEASE_CHECK_EMAIL')}
      </span>
    </div>
  </Modal>
);

StartResetingPasswordSuccessModal.propTypes = {
  resetModal: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch => ({
  dispatch,
  resetModal: () => dispatch(resetModal())
});

export default connect(
  null,
  mapDispatchToProps
)(StartResetingPasswordSuccessModal);



// WEBPACK FOOTER //
// ./src/modals/StartResetingPasswordSuccessModal.js